"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/radix/tooltip";
import { SkeletonLoader } from "@/components/ui/skeleton";
import { Info } from "lucide-react";
import Image from "next/image";
interface SpaceItemProps {
  icon: string;
  label: string;
  available: boolean;
  value: string;
  isLoading?: boolean;
  tooltip?: React.ReactNode;
}
export function SpaceItem(t0) {
  const $ = _c(20);
  const {
    icon,
    label,
    available,
    value,
    isLoading: t1,
    tooltip
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const t2 = `/images/spaces/colored/${icon}.svg`;
  let t3;
  if ($[0] !== label || $[1] !== t2) {
    t3 = <div className="w-full h-8 flex items-center justify-center mb-2 group-hover:opacity-100 transition-opacity duration-200"><Image src={t2} alt={label} width={24} height={24} className="text-gray-600" unoptimized={true} /></div>;
    $[0] = label;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== available || $[4] !== isLoading || $[5] !== value) {
    t4 = available || !isLoading ? <span className="text-lg font-bold text-primary group-hover:text-primary/90 transition-colors duration-200">{value.split(/(sft)/i).map(_temp)}</span> : <SkeletonLoader height="16px" width="20px" className="rounded" />;
    $[3] = available;
    $[4] = isLoading;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="w-20 h-20 bg-gradient-to-br from-accent/5 to-accent/10 rounded-xl flex flex-col items-center justify-center mx-auto mb-4 border border-accent/10 hover:border-accent/20 transition-all duration-200 hover:shadow-sm">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== label) {
    t6 = <p className="text-sm font-semibold text-gray-700 leading-tight group-hover:text-gray-900 transition-colors duration-200">{label}</p>;
    $[10] = label;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== tooltip) {
    t7 = tooltip && <Tooltip><TooltipTrigger asChild={true}><Info className="w-4 h-4 text-gray-400 hover:text-gray-600 cursor-help transition-colors" /></TooltipTrigger><TooltipContent className="max-w-[250px] text-justify">{tooltip}</TooltipContent></Tooltip>;
    $[12] = tooltip;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex items-center justify-center gap-1.5">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <div className="text-center group">{t5}{t8}</div>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp(part, i) {
  return part.toLowerCase() === "sft" ? <span key={i} className="text-[10px] font-semibold ml-0.5 uppercase text-gray-500">{part}</span> : part;
}